import useSWR from 'swr';
import { db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';

export function useGlobals() {
  const { data, isLoading } = useSWR('global_settings', async () => {
    try {
      const snap = await getDoc(doc(db, 'settings', 'layout'));
      if (snap.exists()) {
        const data = snap.data();
        return {
          globals: data.globals || {},
          sections: data.sections || []
        };
      }
    } catch (err) {
      console.warn("Failed to fetch layout statistics from Firestore. Falling back to default empty object.", err);
    }
    return { globals: {}, sections: [] };
  });

  return { 
    globals: data?.globals || {}, 
    sections: data?.sections || [],
    loading: isLoading 
  };
}
